import React from 'react';

interface BackButtonComponentInterface {
    handleBackClick: any;
}

function BackButtonComponent({ handleBackClick }: BackButtonComponentInterface) {
    const backArrowIcon = require("../images/backArrow.png");

    return (
        <div className="backButtonLeftArrow" tabIndex={0} onClick={handleBackClick} onKeyDown={(e) => {
            if (e.key === "Enter") {
                handleBackClick();
            }
        }}>
            <img className="backButtonLeftArrowIcon" src={backArrowIcon} alt="back"/>
        </div>
    );
};

export default BackButtonComponent;